// this file added by Bearer Web Developer

import React, { useState } from "react";
import { MenuDrawerContext } from "../../../states/contexts/menuDrawer";

const MenuDrawerProvider: React.FC<{ children: React.ReactNode; }> = ({ children }) => {

    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [swipe, setSwipe] = useState<boolean>(false);
    const swipable = () => { setSwipe(!swipe); }
    const toggleMenuDrawer = (open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }
        setOpenDrawer(open);
    };
    const valueMenuDrawer = { openDrawer, setOpenDrawer, swipe, swipable,toggleMenuDrawer };
    return (
        <MenuDrawerContext.Provider value={valueMenuDrawer}>
            {children}
        </MenuDrawerContext.Provider>
    )
}
export default MenuDrawerProvider;